export const isNoSearchResults = (items, searchQuery) =>
  items.length === 0 && !!searchQuery
